import React, {ReactNode} from 'react';
import {observer} from 'mobx-react-lite';
import {useRootStore, useUserState} from "@stores/AppStateContext";

import {PageType} from "../../../stores/ActivityProvider";
import {hasOtherActiveUsers} from "../../../utils/userHelper";
import {ItemLine} from '../ItemLine';
import {EmptyListView} from '../ListView/EmptyListView'

import './Active.css';

export const Active = observer(() => {
        const rootStore = useRootStore();
        const userState = useUserState();
        const activeWorkspace = rootStore.view.workspace!;
        const activityInfo = userState!.activityProvider!.activity;

        const recentElements: ReactNode[] = [];
        for (const activityPath of activityInfo.keys()) {
            const [wsId, pageType, id] = activityPath.split('#');
            if (pageType !== PageType.DOC) {
                continue
            }
            const usersSet = activityInfo.get(activityPath);
            if (!usersSet || !hasOtherActiveUsers(usersSet, userState!.currentUserId!)) {
                continue;
            }
            const item = activeWorkspace.items.get(id);
            if (!item) {
                continue;
            }
            recentElements.push(
                <ItemLine
                    key={id}
                    item={item}
                    level={0}
                />
            )
        }

        if (recentElements.length === 0) {
            return (
                <EmptyListView view={'active'}/>
            )
        }

        return (
            <div className='Active'>
                {recentElements}
            </div>
        )
    }
)
